import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const Privacypolicy = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>Privacy policy</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <p>your Privacy policy goes here</p>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(Privacypolicy);
